import { alpha } from "@mui/material/styles";
import { BRAND_BLUE } from "../../theme/colors";

export const adminDropdownSx = {
  color: BRAND_BLUE,
  borderRadius: 3,
  backgroundColor: "#fff",
  transition: "border-color 160ms ease, box-shadow 160ms ease",
  "& .MuiSelect-select": { color: BRAND_BLUE, fontWeight: 600 },
  "& .MuiSelect-icon": { color: BRAND_BLUE },
  "& .MuiOutlinedInput-notchedOutline": { borderColor: alpha(BRAND_BLUE, 0.3), borderWidth: 1.5 },
  "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: alpha(BRAND_BLUE, 0.65), borderWidth: 1.5 },
  "&.Mui-focused, & .MuiOutlinedInput-root.Mui-focused": { boxShadow: `0 0 0 3px ${alpha(BRAND_BLUE, 0.1)}` },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline, & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: BRAND_BLUE, borderWidth: 2 },
};

export const adminDropdownMenuProps = {
  PaperProps: {
    sx: {
      mt: 0.75,
      borderRadius: 3,
      border: `1px solid ${alpha(BRAND_BLUE, 0.14)}`,
      boxShadow: `0 12px 32px ${alpha(BRAND_BLUE, 0.14)}`,
      maxHeight: 360,
      "& .MuiList-root": { p: 0.75 },
      "& .MuiMenuItem-root": {
        color: BRAND_BLUE,
        fontWeight: 500,
        borderRadius: 2,
        minHeight: 40,
        whiteSpace: "normal",
        overflowWrap: "anywhere",
        "&:hover, &.Mui-focusVisible": { backgroundColor: alpha(BRAND_BLUE, 0.06) },
        "&.Mui-selected": {
          backgroundColor: alpha(BRAND_BLUE, 0.1),
          fontWeight: 700,
          "&:hover, &.Mui-focusVisible": { backgroundColor: alpha(BRAND_BLUE, 0.15) },
        },
      },
    },
  },
};
